<template>
    <el-tag
        v-if="props.status === 2"
        type="danger"
    >
        已延期</el-tag>
    <el-tag
        v-if="props.status === 3"
        type="warning"
    >
        进行中
    </el-tag>
    <el-tag
        v-if="props.status === 4"
        type="info"
    >
        已完成
    </el-tag>
    <el-tag
        v-if="props.status === 5"
        type="success"
    >
        申请关闭
    </el-tag>
</template>

<script setup>
const props = defineProps({
    status: {
        type: Number,
        default: () => 4
    }
});

</script>

<style>

</style>
